import { render, staticRenderFns } from "./origins.view.vue?vue&type=template&id=722e44bc&scoped=true"
import script from "./origins.view.vue?vue&type=script&lang=ts"
export * from "./origins.view.vue?vue&type=script&lang=ts"
import style0 from "../../components/insights/origins/origins.component.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./origins.view.vue?vue&type=style&index=1&id=722e44bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e44bc",
  null
  
)

export default component.exports